angular.module 'zc.core'

.factory "notificationInterceptor", ($q, $injector) ->
  NotificationChannel = undefined

  success = (res) ->
    # get $http via $injector because of circular dependency problem
    $http = $http or $injector.get("$http")
    # don't send notification until all requests are complete
    if $http.pendingRequests.length < 1
      # get NotificationChannel via $injector because of circular dependency problem
      NotificationChannel = NotificationChannel or $injector.get("NotificationChannel")
      NotificationChannel.requestEnded()
    res

  error = (res) ->
    # get $http via $injector because of circular dependency problem
    $http = $http or $injector.get("$http")
    # don't send notification until all requests are complete
    if $http.pendingRequests.length < 1
      # get NotificationChannel via $injector because of circular dependency problem
      NotificationChannel = NotificationChannel or $injector.get("NotificationChannel")
      NotificationChannel.requestEnded()
    $q.reject res

  request = (config) ->
    # get NotificationChannel via $injector because of circular dependency problem
    NotificationChannel = NotificationChannel or $injector.get("NotificationChannel")
    NotificationChannel.requestStarted()
    #promise.then success, error
    return config

  return {
    request: request
    response: success
    responseError: error
  }



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/interceptors/notification_interceptor.js.coffee